import React from 'react'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'

@withMutation(gql`
  mutation requestDocumentSignature($documentId: ID) {
    requestDocumentSignature(documentId: $documentId) {
      _id
      signatureRequested
    }
  }
`)
@withMutation(gql`
  mutation sendEmailViewer($documentId: ID) {
    sendEmailViewer(documentId: $documentId) {
     success
    }
  }
`)
@withMessage
export default class SendButton extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    document: PropTypes.object,
    requestDocumentSignature: PropTypes.func,
    sendEmailViewer: PropTypes.func
  }

  state = {}

  @autobind
  async request() {
    this.setState({ loading: true })

    try {
      await this.props.requestDocumentSignature(
        {
          documentId: this.props.document._id
        },
        {
          refetchQueries: [
            'getDocument',
            'documentCount',
            'organizationDocCount',
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'planSignaturesCount',
            'packsSignaturesCount'
          ]
        }
      )

    await this.props.sendEmailViewer({documentId: this.props.document._id})
      this.props.showMessage('Success')
    } catch (error) {
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  renderOnlyMe() {
    let tieneFES = this.props.document.signers && this.props.document.signers.length > 0
    let tieneFea = this.props.document.feaSigners && this.props.document.feaSigners.length > 0
    let finalizaBtnText = 'Finalizar'
    // console.log("TieneFes: " + tieneFES + ", tieneFea: "+ tieneFea);
    if (!tieneFES && tieneFea) {
      finalizaBtnText = 'Enviar'
    }
    return (
      <Button
        tooltip={
          'El documento no permitirá mas ediciones de nombre o secciones de firma'
        }
        onClick={this.request}
        primary
        loading={this.state.loading}
        disabled={!this.props.document.fieldsAssigned}
      >
        {finalizaBtnText}
      </Button>
    )
  }

  renderSend() {
    return (
      <Button
        tooltip={
          this.props.document.fieldsAssigned
            ? 'El documento no permitirá mas ediciones de nombre o secciones de firma'
            : 'Hay campos que no estan asignados o firmantes sin campos asignados'
        }
        onClick={this.request}
        primary
        loading={this.state.loading}
        disabled={!this.props.document.fieldsAssigned}
      >
        Enviar a firmar
      </Button>
    )
  }

  render() {
    if (this.props.document.mySignOnly) {
      return this.renderOnlyMe()
    }
    return this.renderSend()
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/OwnerButtons/SendButton/index.js